import { z } from "zod";

export interface DefaultPriceData {
  fecha: string;
  fechaCotizacion: string;
  precioSoja: number;
  precioMaiz: number;
  precioTrigo: number;
}

export interface DefaultBoardData extends DefaultPriceData {
  precioGirasol: number;
  precioSorgo: number;
}

export interface DollarValue {
  fecha: string;
  compra: number;
  venta: number;
}

export interface PricesData {
  preciosMercado: DefaultPriceData[];
  preciosUnion: DefaultPriceData[];
}

export interface SuppliesData {
  insumos: DefaultPriceData[];
}

export interface DollarData {
  dolarDivisa: DollarValue[];
}

export interface BoardData {
  pizarra: DefaultBoardData[];
}

export interface GeneralFilterData {
  preciosMercado: DefaultPriceData[];
  preciosUnion: DefaultPriceData[];
  insumos: DefaultPriceData[];
  dolarDivisa: DollarValue[];
  pizarra: DefaultBoardData[];
}

export const priceBoardCreateUpdateSchema = z.object({
  fecha: z.any().optional(),
  fechaPizarra: z.any().optional(),
  sojaMercado: z.any().optional(),
  maizMercado: z.any().optional(),
  trigoMercado: z.any().optional(),
  sojaUnion: z.any().optional(),
  maizUnion: z.any().optional(),
  trigoUnion: z.any().optional(),
  sojaInsumos: z.any().optional(),
  maizInsumos: z.any().optional(),
  trigoInsumos: z.any().optional(),
  sojaPizarra: z.any().optional(),
  maizPizarra: z.any().optional(),
  trigoPizarra: z.any().optional(),
});
export type PriceBoardFormValues = z.infer<typeof priceBoardCreateUpdateSchema>;
